import {PolymerElement, html} from '@polymer/polymer';
import {ScopeBinding} from './behaviors/keli-binding-behavior.js';
import {ActionBehavior} from './behaviors/action-behavior';

class KeliButtonMenuItem extends ScopeBinding(ActionBehavior(PolymerElement)) {
  static get template() {
    return html`
      <style>
        :host {
          display: block;
          padding: .5em .7em;
          cursor: pointer;
          white-space: nowrap;
          color: var(--keli-text);
        }

        :host(:hover) {
          background-color: var(--keli-action-hover-background);
        }

        .hotkey {
          font-size: .8em;
          color: var(--keli-text-subtle);
        }
      </style>

      [[caption]]
      <template is="dom-if" if="[[formattedHotkey]]"><span class="hotkey">[[[formattedHotkey]]]</span></template>`;
  }

  static get is() {
    return 'keli-button-menu-item';
  }

  static get properties() {
    return {
      keliControlTypes: {type: Array, value: ['button-menu-item']},
      caption: {type: String, scopevar: true},
      hotkeys: {type: Array, observer: 'hotkeysChanged'},
      formattedHotkey: {type: String, computed: 'computeFormattedHotkey(hotkeys)'},
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.activate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.activate);
  }

  computeFormattedHotkey(hotkeys) {
    if (KeliInterface.isTouchDevice) {
      return;
    }
    if (hotkeys) {
      return formatHotkeyAsText(hotkeys);
    }
  }

  hotkeysChanged(newValue, oldValue) {
    if (oldValue && oldValue.length) {
      oldValue.forEach(hotkey => {
        this.dispatchEvent(new CustomEvent('unregisterPanelHotkey', {
          bubbles: true,
          composed: true,
          detail: {'keys': hotkey}
        }));
      });
    }

    if (newValue && newValue.length) {
      newValue.forEach(hotkey => {
        this.dispatchEvent(new CustomEvent('registerPanelHotkey', {
          bubbles: true,
          composed: true,
          detail: {'keys': hotkey, 'scope': this}
        }));
      });
    }
  }

  activate(event) {
    // Prevent more than one action in a sequence
    if (event?.repeat || event?.detail > 1) {
      return;
    }

    this._activate.call(this, event);

    this.dispatchEvent(new CustomEvent('menuItemActivated', {
      bubbles: true,
      composed: true,
      detail: {element: this}
    }));
  }
}

customElements.define(KeliButtonMenuItem.is, KeliButtonMenuItem);
export {KeliButtonMenuItem};
